<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-11 18:14:47
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-12 14:05:57
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\cardItemFooter.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="font-h6-regular flex-row-align-center yx-color-text-secondary">
		<ButtonGroup :lineHeight="8">
			<span>预估销售额</span>
			<span class="ml-4 yx-color-text-primary">{{ row.total_pay_amount | formatEmpty | formatPrice | formatPrice2 }}</span>
		</ButtonGroup>
		<ButtonGroup :lineHeight="8">
			<span>预估销量</span>
			<span class="ml-4 yx-color-text-primary">{{ row.total_num | formatEmpty }}</span>
		</ButtonGroup>
		<ButtonGroup :lineHeight="8" v-if="$auth.hasPermi('system:goods-ServiceRate')">
			<span>预估服务费收入</span>
			<el-tooltip content="订单付款金额*原始服务费率 ，未扣除技术服务费" placement="top">
				<i class="el-icon-question yx-color-text-placeholder ml-2"></i>
			</el-tooltip>
			<span class="ml-4 yx-color-text-primary">{{ row.partner_estimated_commission_income | formatEmpty | formatPrice | formatPrice2 }}</span>
		</ButtonGroup>
		<ButtonGroup :lineHeight="8" v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])">
			<span>预估服务费支出</span>
			<el-tooltip content="订单付款金额*二级团长服务费率" placement="top">
				<i class="el-icon-question yx-color-text-placeholder ml-2"></i>
			</el-tooltip>
			<span class="ml-4 yx-color-text-primary">{{ row.partner_estimated_commission_pay | formatEmpty | formatPrice | formatPrice2 }}</span>
		</ButtonGroup>
		<ButtonGroup :lineHeight="8" v-if="$auth.hasPermi('system:goods-ServiceRate') && $isPlatOr(row.platform_id, ['Dy', 'Ks'])">
			<span>预估到手服务费(元)</span>
			<el-tooltip class="item" effect="dark" content="订单付款金额*（原始服务费率-二级团长服务费率），并扣除技术服务费" placement="top">
				<i class="el-icon-question yx-color-text-placeholder ml-2"></i>
			</el-tooltip>
			<span class="ml-4 yx-color-text-primary">{{ row.partner_estimated_commission | formatEmpty | formatPrice | formatPrice2 }}</span>
		</ButtonGroup>
		<ButtonGroup :lineHeight="8">
			<span>{{ row.achievement_day | formatEmpty }} 更新</span>
			<el-tooltip class="item" effect="dark" content="每日更新前一天的数据" placement="top">
				<i class="el-icon-question yx-color-text-placeholder ml-2"></i>
			</el-tooltip>
		</ButtonGroup>
	</div>
</template>
<script>
import ButtonGroup from '@/components/ui/buttonGroup';
export default {
	components: {
		ButtonGroup,
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {},
};
</script>
